import type { OrderStatus, PaymentStatus } from '../types/order';
import { SHIPPING_METHOD_INFO } from './shipping';

export const ORDER_STATUS_LABELS: Record<OrderStatus, string> = {
  pending: 'In attesa',
  confirmed: 'Confermato',
  processing: 'In preparazione',
  shipped: 'Spedito',
  delivered: 'Consegnato',
  completed: 'Completato',
  cancelled: 'Annullato',
  refunded: 'Rimborsato',
};

export const PAYMENT_STATUS_LABELS: Record<PaymentStatus, string> = {
  pending: 'In attesa',
  paid: 'Pagato',
  failed: 'Fallito',
  refunded: 'Rimborsato',
  cancelled: 'Annullato',
};

export const PAYMENT_METHOD_LABELS: Record<string, string> = {
  stripe: 'Carta (Stripe)',
};

export const shippingMethodLabel = (method: string | null | undefined) =>
  SHIPPING_METHOD_INFO.find((m) => m.value === method)?.label ?? method ?? '—';

export const orderStatusLabel = (status: string) =>
  ORDER_STATUS_LABELS[status as OrderStatus] ?? status;

export const paymentStatusLabel = (status: string) =>
  PAYMENT_STATUS_LABELS[status as PaymentStatus] ?? status;

// Stati di una contestazione Stripe (https://docs.stripe.com/api/disputes/object)
export const DISPUTE_STATUS_LABELS: Record<string, string> = {
  warning_needs_response: 'Richiesta di informazioni: rispondi su Stripe',
  warning_under_review: 'Richiesta di informazioni in revisione',
  warning_closed: 'Richiesta di informazioni chiusa',
  needs_response: 'Contestazione aperta: rispondi su Stripe',
  under_review: 'Contestazione in revisione',
  won: 'Contestazione vinta',
  lost: 'Contestazione persa',
};

/** Contestazione ancora aperta: l'ordine non va spedito. */
export const isDisputeOpen = (status: string | null | undefined) =>
  !!status && !['won', 'lost', 'warning_closed'].includes(status);

export const cardLabel = (brand: string | null, last4: string | null) => {
  if (!last4) return null;
  const names: Record<string, string> = {
    visa: 'Visa', mastercard: 'Mastercard', amex: 'American Express', maestro: 'Maestro',
    discover: 'Discover', diners: 'Diners', jcb: 'JCB', unionpay: 'UnionPay', cartes_bancaires: 'Cartes Bancaires',
  };
  return `${names[brand ?? ''] ?? (brand ? brand[0].toUpperCase() + brand.slice(1) : 'Carta')} •••• ${last4}`;
};

export const stripePaymentUrl = (paymentIntentId: string, livemode: boolean | null) =>
  `https://dashboard.stripe.com/${livemode === false ? 'test/' : ''}payments/${paymentIntentId}`;
